<template>
    <div id="add">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-users"></i> Users</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">              
                <div class="column is-6">
                    <div class="field">
                      <bulma-input name="email" v-model="user.email" rules="required|email" placeholder='Email'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="user.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input type="password" name="password" v-model="user.password" rules="required|min:6" placeholder='Password'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input type="password" name="password_confirmation" v-model="user.password_confirmation" rules="required" placeholder='Confirm password'/>
                    </div>                        
                </div>

                <div class="column is-6" v-if="roles && roles.length > 0">
                    <div class="field">
                        <label class="label">Roles:</label>
                        <div class="select is-fullwidth">
                            <select v-model="user.role">
                                <option v-bind:value="role.name" v-for="role in roles">{{role.name}}</option>                                          
                            </select>
                        </div>
                    </div>
                </div>               

            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import RoleRepo from '../../repos/RoleRepo'
import lodash from 'lodash'

export default {
  name: 'users-add',
  components: {},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            roleRepo: new RoleRepo(this.$auth),
            loading: false,
            roles: [],
            projects: [],
            user: {role: 'user', projects:[]},
        }
  },
  created(){  
    this.getRoles();    
  },
  methods: {
    getRoles(){
        this.roleRepo.all().then(response => {            
            this.roles = response.data.data;
        });         
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;
                this.repo.store(this.user).then(function (response) {
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/users/Add.vue